import React from 'react';

import get from 'lodash/get';
import { format } from 'date-fns';
import classNames from 'classnames';

import User from './User';
import UserRole from './UserRole';
import Badge from './Badge';

const formatter = new Intl.NumberFormat('en', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
});

export default function Cell({ row, col }) {
  const { type } = col;
  let content = null;
  let value = get(row, col.key);

  if (col.format) {
    value = col.format(value, row);
  }

  switch (type) {
    case 'component':
      content = <col.component {...col.props(row)} />;
      break;
    case 'user':
      content = <User row={row} />;
      break;
    case 'userRole':
      content = <UserRole row={row} />;
      break;
    case 'date':
      content = value ? format(new Date(value), 'MM/dd/yy') : '';
      break;
    case 'currency':
      content = value ? formatter.format(value) : '';
      break;
    case 'badge':
      content = <Badge value={value} color={col.color(value)} />;
      break;
    default:
      content = value;
  }

  return (
    <td
      scope="row"
      className={classNames(
        'px-4 py-3 font-normal text-gray-900 dark:text-white',
        {
          'whitespace-nowrap': !col.textWrap,
          'cursor-pointer text-primary-600 underline': col.onClick,
        }
      )}
      onClick={() => {
        col?.onClick?.(value, row);
      }}
    >
      {content}
    </td>
  );
}
